export default __webpack_public_path__ + "static/media/homeV2Banner.f515c1bc.png";